import { render, staticRenderFns } from "./B2BReportBox.vue?vue&type=template&id=48d0bc4a&scoped=true"
import script from "./B2BReportBox.vue?vue&type=script&lang=js"
export * from "./B2BReportBox.vue?vue&type=script&lang=js"
import style0 from "./B2BReportBox.vue?vue&type=style&index=0&id=48d0bc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0bc4a",
  null
  
)

export default component.exports